export default ({
  formComponents
}) => ({
  root: {
    marginBottom: formComponents.container.marginBottom,
    display: ({ inline }) => (inline ? 'flex' : 'block'),

    '& > div': {
      flex: ({ inline }) => (inline ? 1 : undefined)
    }
  }
});
